import { left, Either } from "fp-ts/lib/Either";

type EitherFunction = (...args: any) => Either<string[], any>;

export function catchAndLogExceptions<T extends EitherFunction>(func: T): T {
  return ((...args) => {
    try {
      return func(...args);
    } catch (e) {
      console.log(
        "[Breakdance - catchAndLogExceptions] an exception occurred in function: ",
        func
      );
      console.error(e);
      return left(["an exception occured, check the console"]);
    }
  }) as T; /* how to make this type safe, so it works without as T? */
}

/* here's my first wizard like shit to wrap shit with tryCatch, but the types are wrong */

// import { tryCatch, Left } from "fp-ts/lib/Either";

// type LolEitherFunc<L, R> = (...args: any) => Either<L, R>;

// export function handleFuckery<L, R, T extends LolEitherFunc<L, R>>(func: T): T {
//   // @ts-ignore
//   return () => {
//     const result = tryCatch(func, e => {
//       console.log(e);
//       return left(["errors, check the console"]);
//     });

//     if (result._tag === "Left") {
//       return (result.left as unknown) as Left<L>;
//     } else {
//       return (result.right as unknown) as Either<L, R>;
//     }
//   };
// }

/*
  Enclose external code we don't control in an IIFE (https://developer.mozilla.org/en-US/docs/Glossary/IIFE)
  to prevent polluting Global, Try/Catch the code and log errors in the script to the user.
  Use window.parent because it runs in the canvas iframe and not in the main window.
 */
export function inlineTryCatchIIFE(script: string, errorMessage: string) {
  const safeScript = script.replace(/`/g, "\\`").replace(/\$/g, "\\$");

  return `
      (function(){
        try {
          eval(\`${safeScript}\`);
        } catch (e) {
          window.parent.Breakdance.NotificationLogger.log.message(
            \`${errorMessage}. Error:"\${e}"\`
          );
          console.error(\`${safeScript}\`);
          console.error(e);
        }
      })();
      `;
}
